import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, EMPTY, share, switchMap } from 'rxjs';
import { UserSettingsService } from '../../services/user-settings.service';
import { UserSettingsModels } from '@share-models';
import { TranslationService } from '../../services/translation.service';
import { UserSettingsActions } from '../state/user-settings/user-settings.actions';

export const getMe = createEffect(
  (
    actions$ = inject(Actions),
    userSettingsService = inject(UserSettingsService),
  ) =>
    actions$.pipe(
      ofType(UserSettingsActions.getMe),
      switchMap(({ language }) =>
        userSettingsService.me(language).pipe(
          switchMap((res) => {
            if (!res) {
              return [UserSettingsActions.getMeFail()];
            }
            return [
              UserSettingsActions.setUserSettings({ userSettings: res }),
              UserSettingsActions.setInterfaceLanguage({ lang: res.lang }),
            ];
          }),
          // TODO implement toast once the toast feature is implemented
          catchError(() => [UserSettingsActions.getMeFail()]),
        ),
      ),
      share(),
    ),
  { functional: true },
);

export const setInterfaceLanguage = createEffect(
  (
    actions$ = inject(Actions),
    translationService = inject(TranslationService),
  ) =>
    actions$.pipe(
      ofType(UserSettingsActions.setInterfaceLanguage),
      switchMap(({ lang }) => {
        const interfaceLanguage = lang ?? UserSettingsModels.DEFAULT_LANGUAGE;
        translationService.setLanguage(interfaceLanguage);
        return [EMPTY];
      }),
      share(),
    ),
  { functional: true, dispatch: false },
);
